import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
  exchangeDirectionsMetaSelector,
  exchangeDirectionsSelector,
  getExchangeDirections,
  isLoadingExchangeDirectionsSelector,
} from 'src/store/app';

import { CustomPagination, PageLoader, WhiteCard } from 'src/components';

import { REACT_APP_API_URL } from 'src/constants';

import { LinkIcon } from 'src/assets';
import './userExchangeDirections.scss';

export const UserExchangeDirections = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const exchangeDirections = useSelector(exchangeDirectionsSelector);
  const exchangeDirectionsMeta = useSelector(exchangeDirectionsMetaSelector);
  const isLoading = useSelector(isLoadingExchangeDirectionsSelector);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getExchangeDirections());
  }, [dispatch, i18n.language]);

  const onChangePage = useCallback(
    (page) => {
      setCurrentPage(page);
      dispatch(getExchangeDirections({ page: page?.toString() }));
    },
    [dispatch],
  );

  const columns = [
    {
      id: 1,
      key: 'givingCurrency',
      label: t('label:givingCurrency'),
      value: ({ given }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={REACT_APP_API_URL + given?.image}
            alt={REACT_APP_API_URL + given?.image}
            style={{ width: 18, height: 18, marginRight: 10 }}
          />
          {given?.code}
        </div>
      ),
    },
    {
      id: 2,
      key: 'receivingCurrency',
      label: t('label:receivingCurrency'),
      value: ({ received }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={REACT_APP_API_URL + received?.image}
            alt={REACT_APP_API_URL + received?.image}
            style={{ width: 18, height: 18, marginRight: 10 }}
          />
          {received?.code}
        </div>
      ),
    },
    {
      id: 3,
      key: 'exchangeCourse',
      label: t('label:exchangeCourse'),
      value: ({ given, received }) => {
        return (
          <div>
            {given.rate_given_currency}{' '}
            <span className="admin-builder__text--gray">{given.code}</span> ={' '}
            {received.rate_received_currency}{' '}
            <span className="admin-builder__text--gray">{received.code}</span>
          </div>
        );
      },
    },
    {
      id: 4,
      key: 'minMaxSumm',
      label: t('label:minMaxSumm'),
      value: ({ given, received, min_exchange, max_exchange }) => {
        return (
          <div>
            {min_exchange} <span className="admin-builder__text--gray">{given.code}</span> /{' '}
            {max_exchange} <span className="admin-builder__text--gray">{received.code}</span>
          </div>
        );
      },
    },
  ];

  return (
    <div className="exchange-directions">
      {isLoading ? <PageLoader /> : null}

      <h2>{t('exchangeDirection:main')}</h2>
      <WhiteCard>
        <div className="custom-table__wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                {columns?.map((item, index) => (
                  <th key={index}>{item.label}</th>
                ))}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {exchangeDirections?.map((item) => {
                return (
                  <tr key={item.id}>
                    {columns.map((column) => {
                      const value =
                        typeof column.value === 'function'
                          ? column.value(item)
                          : item?.[column?.key];

                      return <td key={item.id + column.id}>{value}</td>;
                    })}
                    <td style={{ textAlign: 'center' }}>
                      <Link to={`/exchange/${item?.id}/create`}>
                        <img src={LinkIcon} alt={LinkIcon} />
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <CustomPagination
          totalItems={exchangeDirectionsMeta?.total_items}
          initialPage={currentPage}
          initialPerPage={exchangeDirectionsMeta?.per_page}
          onPageChange={onChangePage}
          withSelect={false}
        />
      </WhiteCard>
    </div>
  );
};
